import { REPORT_CHANNEL, ZT_ROOT_ADDRESS } from '@src/constants';
import queryParams from '@src/utils/getAppId';
import { LANGUAGE_NAME } from '@src/utils/locale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

export const config = {
  appId: '200001086',
  appVersion: '1.0',
  channel: REPORT_CHANNEL,
  createCommonAttributes: () => {
    return {
      gameAppId: queryParams.appId ? queryParams.appId : '',
      language: LANGUAGE_NAME[getLanguageByPath()],
      post_url: ZT_ROOT_ADDRESS
    };
  }
};

const gaTrackerBaseEvent = {
  // 发送埋点
  send: (event_name, event_options) => {
    // eslint-disable-next-line no-undef
    // gtag('event', event_name, event_options);
  }
};

export default function createTracker(report, getDiffRouteTime) {
  return {
    loginAccountStart: function(emailAddress, way, accountId = 'guest') {
      // console.log('loginAccountStart', emailAddress, way);
      const customEventInfo = {
        msgType: 'custom.event',
        accountId, //账号ID 确保全局唯一
        roleId: '', //角色ID
        roleName: '', //角色名
        roleType: '', //角色类型,如法师，道士，战士
        roleLevel: '', //角色等级
        roleVipLevel: '', //角色vip等级
        zone: '', //游戏区ID
        zoneName: '', //游戏区名称
        server: '', //游戏服ID,示例:s1,s2
        serverName: '', //游戏服名称,示例:风云争霸
        partyId: '', //公会ID
        gender: '', //角色性别 m:男 f:女
        battleScore: '', //战斗力
        eventId: 'loginaccountstart', //事件ID
        eventDesc: '开始登录账号', //事件描述
        eventBody: { emailaddress: emailAddress, way } //事件体
      };
      report(customEventInfo);
      gaTrackerBaseEvent.send('loginaccountstart', { emailaddress: emailAddress, way });
    },
    loginAccountSuccess: function(emailAddress, way, accountId = 'guest') {
      // console.log('loginAccountSuccess', emailAddress, way);
      const customEventInfo = {
        msgType: 'custom.event',
        accountId, //账号ID 确保全局唯一
        roleId: '', //角色ID
        roleName: '', //角色名
        roleType: '', //角色类型,如法师，道士，战士
        roleLevel: '', //角色等级
        roleVipLevel: '', //角色vip等级
        zone: '', //游戏区ID
        zoneName: '', //游戏区名称
        server: '', //游戏服ID,示例:s1,s2
        serverName: '', //游戏服名称,示例:风云争霸
        partyId: '', //公会ID
        gender: '', //角色性别 m:男 f:女
        battleScore: '', //战斗力
        eventId: 'loginaccountsuccess', //事件ID
        eventDesc: '登录账号成功', //事件描述
        eventBody: { emailaddress: emailAddress, way, accountId } //事件体
      };
      report(customEventInfo);
      gaTrackerBaseEvent.send('loginaccountsuccess', { emailaddress: emailAddress, way, accountId });
    },
    loginAccountFail: function(emailAddress, codeStatus, code, accountId = 'guest') {
      // console.log('loginAccountFail', emailAddress, code);
      const customEventInfo = {
        msgType: 'custom.event',
        accountId, //账号ID 确保全局唯一
        roleId: '', //角色ID
        roleName: '', //角色名
        roleType: '', //角色类型,如法师，道士，战士
        roleLevel: '', //角色等级
        roleVipLevel: '', //角色vip等级
        zone: '', //游戏区ID
        zoneName: '', //游戏区名称
        server: '', //游戏服ID,示例:s1,s2
        serverName: '', //游戏服名称,示例:风云争霸
        partyId: '', //公会ID
        gender: '', //角色性别 m:男 f:女
        battleScore: '', //战斗力
        eventId: 'loginaccountfail', //事件ID
        eventDesc: '登录账号失败', //事件描述
        eventBody: { emailaddress: emailAddress, code, codestatus: codeStatus } //事件体
      };
      report(customEventInfo);
      gaTrackerBaseEvent.send('loginaccountfail', { emailaddress: emailAddress, code, codestatus: codeStatus });
    },
    registerAccountStart: function(emailAddress, accountId = 'guest') {
      console.log('registerAccountStart', emailAddress);
      const customEventInfo = {
        msgType: 'custom.event',
        accountId, //账号ID 确保全局唯一
        roleId: '', //角色ID
        roleName: '', //角色名
        roleType: '', //角色类型,如法师，道士，战士
        roleLevel: '', //角色等级
        roleVipLevel: '', //角色vip等级
        zone: '', //游戏区ID
        zoneName: '', //游戏区名称
        server: '', //游戏服ID,示例:s1,s2
        serverName: '', //游戏服名称,示例:风云争霸
        partyId: '', //公会ID
        gender: '', //角色性别 m:男 f:女
        battleScore: '', //战斗力
        eventId: 'registeraccountstart', //事件ID
        eventDesc: '开始注册账号', //事件描述
        eventBody: { emailaddress: emailAddress } //事件体
      };
      report(customEventInfo);
      gaTrackerBaseEvent.send('registeraccountstart', { emailaddress: emailAddress });
    },
    registerAccountSuccess: function(emailAddress, accountId = 'guest') {
      console.log('registerAccountSuccess', emailAddress);
      const customEventInfo = {
        msgType: 'custom.event',
        accountId, //账号ID 确保全局唯一
        roleId: '', //角色ID
        roleName: '', //角色名
        roleType: '', //角色类型,如法师，道士，战士
        roleLevel: '', //角色等级
        roleVipLevel: '', //角色vip等级
        zone: '', //游戏区ID
        zoneName: '', //游戏区名称
        server: '', //游戏服ID,示例:s1,s2
        serverName: '', //游戏服名称,示例:风云争霸
        partyId: '', //公会ID
        gender: '', //角色性别 m:男 f:女
        battleScore: '', //战斗力
        eventId: 'registeraccountsuccess', //事件ID
        eventDesc: '注册账号成功', //事件描述
        eventBody: { emailaddress: emailAddress, accountId } //事件体
      };
      report(customEventInfo);
      gaTrackerBaseEvent.send('registeraccountsuccess', { emailaddress: emailAddress, accountId });
    },
    registerAccountFail: function(emailAddress, code, codeStatus, accountId = 'guest') {
      console.log('registerAccountFail', emailAddress, code);
      const customEventInfo = {
        msgType: 'custom.event',
        accountId, //账号ID 确保全局唯一
        roleId: '', //角色ID
        roleName: '', //角色名
        roleType: '', //角色类型,如法师，道士，战士
        roleLevel: '', //角色等级
        roleVipLevel: '', //角色vip等级
        zone: '', //游戏区ID
        zoneName: '', //游戏区名称
        server: '', //游戏服ID,示例:s1,s2
        serverName: '', //游戏服名称,示例:风云争霸
        partyId: '', //公会ID
        gender: '', //角色性别 m:男 f:女
        battleScore: '', //战斗力
        eventId: 'registeraccountfail', //事件ID
        eventDesc: '注册账号失败', //事件描述
        eventBody: { emailaddress: emailAddress, code, codestatus: codeStatus } //事件体
      };
      report(customEventInfo);
      gaTrackerBaseEvent.send('registeraccountfail', { emailaddress: emailAddress, code, codestatus: codeStatus });
    },
    forgetPwd: function(accountId = 'guest') {
      console.log('forgetPwd');
      const customEventInfo = {
        msgType: 'custom.event',
        accountId, //账号ID 确保全局唯一
        roleId: '', //角色ID
        roleName: '', //角色名
        roleType: '', //角色类型,如法师，道士，战士
        roleLevel: '', //角色等级
        roleVipLevel: '', //角色vip等级
        zone: '', //游戏区ID
        zoneName: '', //游戏区名称
        server: '', //游戏服ID,示例:s1,s2
        serverName: '', //游戏服名称,示例:风云争霸
        partyId: '', //公会ID
        gender: '', //角色性别 m:男 f:女
        battleScore: '', //战斗力
        eventId: 'forgetpwd', //事件ID
        eventDesc: '忘记密码 ', //事件描述
        eventBody: {} //事件体
      };
      report(customEventInfo);
      gaTrackerBaseEvent.send('forgetpwd', {});
    },
    forgetPassNextStep: function(emailAddress, accountId = 'guest') {
      console.log('forgetPassNextStep', emailAddress);
      const customEventInfo = {
        msgType: 'custom.event',
        accountId, //账号ID 确保全局唯一
        roleId: '', //角色ID
        roleName: '', //角色名
        roleType: '', //角色类型,如法师，道士，战士
        roleLevel: '', //角色等级
        roleVipLevel: '', //角色vip等级
        zone: '', //游戏区ID
        zoneName: '', //游戏区名称
        server: '', //游戏服ID,示例:s1,s2
        serverName: '', //游戏服名称,示例:风云争霸
        partyId: '', //公会ID
        gender: '', //角色性别 m:男 f:女
        battleScore: '', //战斗力
        eventId: 'forgetpassnextstep', //事件ID
        eventDesc: '忘记密码-下一步 ', //事件描述
        eventBody: { emailaddress: emailAddress } //事件体
      };
      report(customEventInfo);
      gaTrackerBaseEvent.send('forgetpassnextstep', { emailaddress: emailAddress });
    },
    resetPwd: function(emailAddress, accountId = 'guest') {
      console.log('resetPwd', emailAddress);
      const customEventInfo = {
        msgType: 'custom.event',
        accountId, //账号ID 确保全局唯一
        roleId: '', //角色ID
        roleName: '', //角色名
        roleType: '', //角色类型,如法师，道士，战士
        roleLevel: '', //角色等级
        roleVipLevel: '', //角色vip等级
        zone: '', //游戏区ID
        zoneName: '', //游戏区名称
        server: '', //游戏服ID,示例:s1,s2
        serverName: '', //游戏服名称,示例:风云争霸
        partyId: '', //公会ID
        gender: '', //角色性别 m:男 f:女
        battleScore: '', //战斗力
        eventId: 'resetpwd', //事件ID
        eventDesc: '忘记密码-下一步 ', //事件描述
        eventBody: { emailaddress: emailAddress } //事件体
      };
      report(customEventInfo);
      gaTrackerBaseEvent.send('resetpwd', { emailaddress: emailAddress });
    },
    setAccountSecurity: function(setContent, way, accountId = 'guest') {
      console.log('setAccountSecurity', setContent, way);
      const customEventInfo = {
        msgType: 'custom.event',
        accountId, //账号ID 确保全局唯一
        roleId: '', //角色ID
        roleName: '', //角色名
        roleType: '', //角色类型,如法师，道士，战士
        roleLevel: '', //角色等级
        roleVipLevel: '', //角色vip等级
        zone: '', //游戏区ID
        zoneName: '', //游戏区名称
        server: '', //游戏服ID,示例:s1,s2
        serverName: '', //游戏服名称,示例:风云争霸
        partyId: '', //公会ID
        gender: '', //角色性别 m:男 f:女
        battleScore: '', //战斗力
        eventId: 'setaccountsecurity', //事件ID
        eventDesc: '账号安全设置 ', //事件描述
        eventBody: { setcontent: setContent, way } //事件体
      };
      report(customEventInfo);
      gaTrackerBaseEvent.send('setaccountsecurity', { setcontent: setContent, way });
    },
    InGamePageLoadError: function() {
      const customEventInfo = {
        msgType: 'custom.event',
        accountId: 'guest', //账号ID 确保全局唯一
        roleId: '', //角色ID
        roleName: '', //角色名
        roleType: '', //角色类型,如法师，道士，战士
        roleLevel: '', //角色等级
        roleVipLevel: '', //角色vip等级
        zone: '', //游戏区ID
        zoneName: '', //游戏区名称
        server: '', //游戏服ID,示例:s1,s2
        serverName: '', //游戏服名称,示例:风云争霸
        partyId: '', //公会ID
        gender: '', //角色性别 m:男 f:女
        battleScore: '', //战斗力
        eventId: 'ingamepageloaderror', //事件ID
        eventDesc: '游戏内注册错误', //事件描述
        eventBody: {} //事件体
      };
      report(customEventInfo);
      gaTrackerBaseEvent.send('ingamepageloaderror', {});
    },
    sendCaptcha: function(email, code, codeStatus, type) {
      const customEventInfo = {
        eventId: 'sendCaptcha', //事件ID
        eventDesc: '发送邮箱验证码', //事件描述
        eventBody: {
          type,
          email,
          code,
          codeStatus
        } //事件体
      };
      report(customEventInfo);
    },
    loadPage: function() {
      /*report({
        eventName: 'load_page',
        eventDescription: '页面加载（默认上报，页面全部加载完成才上报）'
      });*/
    },
    pageLeave: function() {
      /*report({
        eventName: 'page_leave',
        eventDescription: '离开页面（默认上报）'
      });*/
    },
    loadPageStart: function() {
      /*report({
        eventName: 'load_page_start',
        eventDescription: '页面加载（默认上报，进入页面就上报）'
      });*/
    }
  };
}

Number.isInteger =
  Number.isInteger ||
  function(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
  };

function checkTypeHOF(type) {
  switch (type) {
    case 'int':
      return Number.isInteger;
    case 'float':
      return value => typeof value === 'number' && !Number.isInteger(value);
    case 'boolean':
      return value => typeof value === 'boolean';
    case 'string':
      return value => typeof value === 'string';
    default:
      setTimeout(() => {
        throw new Error('st-report: invalid value type = ' + type);
      }, 0);
      return null;
  }
}
